module.exports = __webpack_public_path__ + "img/375_stores_img3.5acdc72b.png";